import { render, staticRenderFns } from "./specials.vue?vue&type=template&id=6eeccb42&scoped=true&"
import script from "./specials.vue?vue&type=script&lang=js&"
export * from "./specials.vue?vue&type=script&lang=js&"
import style0 from "./specials.vue?vue&type=style&index=0&id=6eeccb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeccb42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
